import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { CustomFieldType } from '@platform/core/types';
import type { INewFieldRowProps } from './INewFieldRowProps';
import { newCustomField } from './newCustomField';

/** Типи нового поля (прототип v4 FTYPES без тегів, і прапорець ADR-023). */
const NEW_TYPES: readonly CustomFieldType[] = ['text', 'textarea', 'number', 'select', 'date', 'user', 'checkbox'];

/**
 * Рядок додавання поля (прототип v4 nfLabel / nfType / addField): «Назва нового поля», тип і «+ Додати поле» (або Enter) — нове власне поле
 * простору з ключем cf_… за підписом, як fd() прототипу: необов'язкове й «У списку» (колонка таблиці модуля); поле вибору отримує варіанти
 * «Варіант А», «Варіант Б».
 */
export function NewFieldRow({ taken, lang, canEdit, onAdd }: INewFieldRowProps) {
  const { t } = useTranslation();
  const [label, setLabel] = useState('');
  const [type, setType] = useState<CustomFieldType>('text');
  const add = () => {
    const text = label.trim();
    if (!text) return;
    const options = type === 'select' ? [{ value: t('rtBuilder.optionA') }, { value: t('rtBuilder.optionB') }] : undefined;
    onAdd(newCustomField(text, type, taken, lang, options));
    setLabel('');
    setType('text');
  };
  return (
    <div className="rb-newfield">
      <input className="rb-input rb-newfield__label" value={label} placeholder={t('rtBuilder.newField')} aria-label={t('rtBuilder.newField')} disabled={!canEdit}
        onChange={(e) => setLabel(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') add(); }} />
      <select className="rb-select rb-newfield__type" value={type} disabled={!canEdit} aria-label={t('rtBuilder.cols.type')} onChange={(e) => setType(e.target.value as CustomFieldType)}>
        {NEW_TYPES.map((ty) => <option key={ty} value={ty}>{t(`rtBuilder.types.${ty}`)}</option>)}
      </select>
      <button type="button" className="rb-btn" disabled={!canEdit} onClick={add}>{t('rtBuilder.addField')}</button>
    </div>
  );
}
